import { ParamIds, Places } from 'src/Constants'
import { MainKeys } from 'src/main/Main.keys'

export class AnaliseKeys extends MainKeys {
    get place() {
        return Places.mcAnalise
    }

    public get analiseId() {
        return this._intent.getParameterAsNumber(ParamIds.mcAnaliseFormId)
    }

    public set analiseId(value: number | undefined) {
        this._intent.setParameter(ParamIds.mcAnaliseFormId, value)
    }
}

export default AnaliseKeys
